<app-spinner *ngIf="loading"></app-spinner>
<router-outlet *ngIf="!loading"></router-outlet>
